import { render } from "./AddPagamentoMovimenti.vue?vue&type=template&id=764131b3&scoped=true"
import script from "./AddPagamentoMovimenti.vue?vue&type=script&lang=js"
export * from "./AddPagamentoMovimenti.vue?vue&type=script&lang=js"

import "./AddPagamentoMovimenti.vue?vue&type=style&index=0&id=764131b3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764131b3"]])

export default __exports__